export default __webpack_public_path__ + "static/media/logo-64x64.a6d5ff71.svg";